<div
  [formGroup]="form"
  class="mt-5"
  *ngIf="form.get('selectedRequestNature')?.value === RequestNatureOptions.Termination">
  <label
    for="terminationDate"
    class="block">
    {{ "contactUsForm.terminationDate.label" | translate }}
    <span class="text-red opacity-60">*</span>
  </label>
  <p-calendar
    formControlName="selectedTerminationDate"
    [placeholder]="'contactUsForm.terminationDate.placeholder' | translate"
    class="mt-1 block w-full shadow-sm"
    inputId="terminationDate"
    dateFormat="dd/mm/yy"
    [showIcon]="true"
    appendTo="body"
    [minDate]="minTerminationDate"
    [maxDate]="maxTerminationDate"
    [disabled]="form.get('selectedTerminationDate')!.disabled"></p-calendar>
</div>
